import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Blogs from './pages/Blogs';
import Blog from './pages/Blog';
import User from './pages/User';
import Contact from './pages/Contact';
import Error from './pages/Error';
import './App.css';
import Navbar from './component/Navbar';
import Login from './pages/Login';

function App() {
 
  return (
    <BrowserRouter>
     <Navbar />
      <Routes>
        <Route path='/' element={<Home />}/>
        <Route path='/blogs' element={<Blogs />}/>
        <Route path='/blogs/:title' element={<Blog />}/>
        <Route path='/contact' element={<Contact />}/>
        <Route path='*' element={<Error />}/>
        {/* <Route path='/user/:userid' element={<User />}/> */}
        <Route path='/user' element={<User />}/>
        {/* <Route path='/login' element={<Login />}/> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;


// blogs/contact        -> blog page
// blogs/carrer         -> blog page
// blogs/employemnet    -> blog page
